export default __webpack_public_path__ + "static/media/in_transit.803f3202.svg";